// v0.6.10 — one warning for every path that re-runs the calculation.
//
// Re-running REPLACES the calc. An operator lost 1,079 acknowledgements
// that way and spent an hour convinced the review queue was broken; since
// A2-646 they follow the row, and typed box values are what stays behind.
//
// The Calculate button was guarded first (useAsyncCalc), but runCalc()
// in WorkflowContext is a SECOND way to replace the calc, reached from
// four places that do not look like "re-run the calculation":
// TraceDrawer's "Populate trace", and the VAT-number, refund-channel
// and service-country resolvers. It also posts to the SYNCHRONOUS
// /calculate endpoint, so the replacement calc carries no job record —
// which is why the orphan took so long to trace.
//
// Living in the provider means every caller is covered by
// construction, including ones added later.
import React from "react";
import { BlockingMessageDialog } from "../components/BlockingMessageDialog";
import { useTranslation } from "react-i18next";

export const RerunWarningDialog = ({ pending }) => {
  const { t } = useTranslation();
  return (
  <BlockingMessageDialog
    open={!!pending}
    testid="workflow-rerun-warning"
    severity="warning"
    title={t("ui.calculate.rerun_dialog.title", { defaultValue: "This creates a new calculation" })}
    onOpenChange={(o) => !o && pending?.onCancel?.()}
    actions={[
      {
        label: t("ui.calculate.rerun_dialog.keep", { defaultValue: "Keep the current calculation" }),
        testid: "workflow-rerun-cancel",
        onClick: () => pending?.onCancel?.(),
      },
      {
        label: t("ui.calculate.rerun_dialog.proceed", { defaultValue: "Re-run anyway" }),
        variant: "primary",
        testid: "workflow-rerun-confirm",
        onClick: () => pending?.onProceed?.(),
      },
    ]}
  >
    <p>
      {t("ui.calculate.rerun_dialog.wf_before", { defaultValue: "This creates a NEW calculation. You have reviewed" })}{" "}
      <strong>{pending?.ackedCount}</strong>{" "}
      {t("ui.calculate.rerun_dialog.wf_after", { count: pending?.ackedCount, defaultValue: `${pending?.ackedCount === 1 ? "row" : "rows"}, and most rows still flagged keep that answer in the new calculation. Figures typed into a return do not carry over.` })}
    </p>
    <p className="mt-2">
      {t("ui.calculate.rerun_dialog.wf_not_deleted", { defaultValue: "Nothing is deleted. The current calculation keeps everything if you go back to it." })}
    </p>
  </BlockingMessageDialog>
  );
};

export default RerunWarningDialog;
